import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  card: {
    height: '100%',
    width: '100%',
    whiteSpace: 'pre-wrap',
    color: theme.palette.white,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.hover,
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  cardNumber: {
    backgroundColor: theme.palette.background.default,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    minWidth: theme.spacing(3),
    flexShrink: 0,
  },
  cardNumberText: {
    fontWeight: 800,
    color: theme.palette.secondary.main,
    fontFamily: 'Arial',
  },
}))

export default useStyles
